const example = 
[
    {
      "nombre": "Daniel Ruiz",
      "edad": 42,
      "email": "daniel.ruiz@translogisticamaral.es",
      "esCliente": false,
      "presupuestoEstimado": 1800,
      "serviciosInteresados": ["automatización de procesos", "CRM", "WhatsApp"],
      "serviciosDisponibles": ["CRM", "WhatsApp", "ERP", "Business Intelligence", "automatización de procesos"],
      "horasProyectos": [45, 32, 28],
      "estadosImplementacion": [true, false, null, true, 0, ''],
      "reuniones": [
        { "id": "REU001", "tipo": "exploratoria", "fecha": "2025-05-10" },
        { "id": "REU002", "tipo": "demo técnica", "fecha": "2025-05-15" }
      ],
      "fechaRegistro": "2025-05-16T14:45:20Z",
      "empresa": {
        "nombre": "Translogística Maral S.L.",
        "sector": "Logística",
        "ciudad": "Valencia",
        "empleados": 35
      },
      "implementacionesPrevias": [],
      "proyectosPasados": [
        {
          "nombre": "Gestión de inventario automatizada",
          "estado": "completado",
          "exito": true,
          "horasDedicadas": 45
        },
        {
          "nombre": "Sistema de tickets interno",
          "estado": "en curso",
          "exito": null,
          "horasDedicadas": 32
        },
        {
          "nombre": "Bot para atención al cliente",
          "estado": "cancelado",
          "exito": false,
          "horasDedicadas": 28
        }
      ],
      "contactosInternos": [
        {
          "nombre": "Laura Pérez",
          "email": "laura.perez@translogmaral.com",
          "rol": "COO"
        },
        {
          "nombre": "Sergio Gómez",
          "email": "sergio.gomez@translogmaral.com",
          "rol": "Responsable de IT"
        },
        {
          "nombre": "Clara Ortega",
          "email": "clara.ortega@translogmaral.com",
          "rol": "Asistente técnica"
        }
      ]
    }
]

export default example;